import isEqual from 'lodash/isEqual';
import {
  CreateInteractionBody,
  InteractionType,
  UpdateInteractionBody,
} from '@loyalty/shared-common/profile-api-client';
import { getStarterSamplePayload } from './starter-sample-payloads';

export function isBlankSampleJson(json: string): boolean {
  return json.trim() === '';
}

export function parseContentExampleJson(json: string): Record<string, unknown> | null {
  try {
    const value: unknown = JSON.parse(json);
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      return value as Record<string, unknown>;
    }
    return null;
  } catch {
    return null;
  }
}

export function contentExampleForSave(
  type: InteractionType,
  sample: object | null | undefined,
): Record<string, unknown> | null {
  if (!sample || Array.isArray(sample)) {
    return null;
  }

  if (isEqual(sample, getStarterSamplePayload(type))) {
    return null;
  }

  return sample as Record<string, unknown>;
}

export function buildInteractionSaveBody(
  value: {
    name: string;
    type?: InteractionType;
    detailTemplate: string;
    contentExample: object | null | undefined;
  },
  type: InteractionType,
): CreateInteractionBody | UpdateInteractionBody {
  return {
    name: value.name,
    type,
    detailTemplate: value.detailTemplate,
    contentExample: contentExampleForSave(type, value.contentExample),
  };
}

export function sampleJsonForEditor(
  type: InteractionType,
  contentExample: Record<string, unknown> | null | undefined,
): string {
  const payload =
    contentExample && typeof contentExample === 'object' && !Array.isArray(contentExample)
      ? contentExample
      : getStarterSamplePayload(type);

  return JSON.stringify(payload, null, 2);
}
